'use strict';

import '@ungap/custom-elements';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
require('reactive-elements');

interface Iprops {
    accountLink: string;
    dashboardLink: string;
    helpLink: string;
    optionsLink: string;
    notificationsLink: string;
}

const SubNav: React.SFC<Iprops> = props => {
    let {
        accountLink,
        dashboardLink,
        helpLink,
        optionsLink,
        notificationsLink,
    } = props;

    return (
        <div className="pageRight container">
            {dashboardLink && (
                <a href={dashboardLink} target="_blank">
                    My Cengage Home
                </a>
            )}
            {notificationsLink && <a href={notificationsLink}>Notifications</a>}
            {helpLink && <a href={helpLink}>Help</a>}
            {!accountLink ? (
                <a href={optionsLink}>My Options</a>
            ) : (
                <a
                    href={accountLink}
                    data-analytics="account-settings-launch"
                    target="_blank"
                >
                    My Account
                </a>
            )}
        </div>
    );
};

document.addEventListener('DOMContentLoaded', () => {
    let root: any = document.querySelector('#js-student-subnav');
    if (root) {
        ReactDOM.render(<SubNav {...root.dataset} />, root);
    }
});

export default SubNav;
